import {
  type UseQueryOptions,
  type UseQueryReturnType,
  useQuery,
} from '@tanstack/vue-query'
import type { MaybeRef } from '@vueuse/core'
import type { GetArg, GetReturn } from '~~/src/types/utils'
import { getTopics } from '~~/src/api/topics'

type Args = GetArg <typeof getTopics >

export const useTopicsQuery = (
  args: {
    query: MaybeRef<Args[0]>
  },
  options?: MaybeRef< Omit<
  UseQueryOptions<
    GetReturn<typeof getTopics>,
    Error
  >,
  'queryKey' | 'queryFn' | 'placeholderData' | 'keepPreviousData'
>>,
): UseQueryReturnType<GetReturn<typeof getTopics>, Error> => {
  return useQuery({
    queryKey: ['topics', args.query] as const,
    queryFn: async ({ queryKey }) => {
      const [_, query] = queryKey
      return await getTopics(query)
    },
    ...options,
  })
}
